// import {
//   DashboardOutlined,
//   TeamOutlined,
//   PlusOutlined,
//   MinusOutlined,
//   SwapOutlined,
//   HistoryOutlined,
//   BankOutlined,
//   UserOutlined,
//   SettingOutlined,
//   FileTextOutlined,
// } from "@ant-design/icons";

// rawPermissionsData  SuperOwner

export const rawPermissionsData = [
  {
    roleId: 66,
    permissionId: 1,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "dashboard_view",
    description: "สามารถเข้าถึงเมนู สถานะบัญชี",
    uuid: "3a2959db-a276-45d2-a700-5f2fbf67f289",
    action: "view",
    resource: "Dashboard",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:16.000Z",
    updated_at: "2025-02-08T23:18:08.000Z",
  },
  {
    roleId: 66,
    permissionId: 2,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "customer_account_view",
    description: "สามารถเข้าถึงเมนู Customer",
    uuid: "035d56e7-4720-4eb4-9d4e-60be5d46d46a",
    action: "view",
    resource: "Customer",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 3,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "deposit_customer_transactions_view",
    description: "สามารถเข้าถึงเมนู Deposit",
    uuid: "4cbae83a-081a-44cd-81be-4bf67801f164",
    action: "view",
    resource: "Deposit",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 7,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "withdraw_customer_transactions_view",
    description: "สามารถเข้าถึงเมนู ธุรกรรมลูกค้า - ถอน withdraw-transaction",
    uuid: "11cf9e86-8673-40d2-946b-2cd3ad72ac1a",
    action: "view",
    resource: "Withdraw",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 12,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "merchant_transfer_view",
    description: "สามารถเข้าถึงเมนู รายการโอน client-transfer",
    uuid: "24e2b988-5c7e-4a17-a32a-49bef98ded1e",
    action: "view",
    resource: "BankAccount",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 13,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "statement_view",
    description: "สามารถเข้าถึงเมนู รายการเดินบัญชี statement",
    uuid: "5e9bb337-9067-40d2-aae2-f5fed12309ab",
    action: "view",
    resource: "BankAccount",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 15,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "manage_user_view",
    description: "สามารถเข้าถึงเมนู ผู้ใช้งาน user",
    uuid: "5f2abe4f-b397-43dc-b9a3-502442c5a5aa",
    action: "view",
    resource: "User",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 16,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "activity_user_view",
    description: "สามารถเข้าถึงเมนู บันทึกกิจกรรม user-activity",
    uuid: "64b2adb5-4c40-410f-b25a-83c46db10022",
    action: "view",
    resource: "User",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 17,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "role_view",
    description: "สามารถเข้าถึงเมนู Role",
    uuid: "8278c391-bff9-4187-86c1-385939b119e1",
    action: "view",
    resource: "User",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 18,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "setting_view",
    description: "สามารถเข้าถึงเมนู setting",
    uuid: "b3e6ab5c-a54d-400e-b95b-51896247fc12",
    action: "view",
    resource: "Setting",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 66,
    permissionId: 19,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "ApiDocumentation_view",
    description: "สามารถเข้าถึงเมนู Api Documentation",
    uuid: "5b30e08e-d495-45d4-a675-bf92b7ac5051",
    action: "view",
    resource: "ApiDocumentation",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-14T01:18:59.000Z",
  },
  {
    roleId: 66,
    permissionId: 20,
    isPublic: 0,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "auto_slip_with_Qr",
    description: "สามารถเข้าถึงเมนู ตรวจสอบสลิป",
    uuid: "2b30e08e-i495-75d4-f675-bf92b7ac5051",
    action: "view",
    resource: "CheckSlip",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: false,
    created_at: "2025-02-26T05:05:37.000Z",
    updated_at: "2025-07-06T01:18:59.000Z",
  },
  {
    roleId: 66,
    permissionId: 21,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "auto_slip_check_with_Qr",
    description: "สามารถเข้าถึงเมนู รายการตรวจสอบสลิป",
    uuid: "1a70e08e-s495-85d4-f675-uf92b7ac5051",
    action: "view",
    resource: "CheckSlip",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 66,
    permissionId: 22,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "manage_merchant_view",
    description: "สามารถเข้าถึงเมนู จัดการร้านค้า",
    uuid: "1a70e08e-s495-8574-f675-uf92b7ac5052",
    action: "view",
    resource: "Merchant",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 66,
    permissionId: 23,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "bankAccount_view",
    description: "สามารถเข้าถึงเมนู จัดการธนาคาร",
    uuid: "1a70e08e-s495-85d4-f675-uf99b7ac5052",
    action: "view",
    resource: "BankAccount",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 66,
    permissionId: 24,
    isPublic: 1,
    createdAt: "2025-08-02T07:21:00.000Z",
    updatedAt: "2025-08-02T07:21:00.000Z",
    name: "chart_report_view",
    description: "สามารถเข้าถึงเมนู report",
    uuid: "1a70e08e-s495-85d4-p675-uf92b7ac5052",
    action: "view",
    resource: "Report",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 66,
    permissionId: 25,
    isPublic: 0,
    createdAt: "2025-08-02T07:26:27.000Z",
    updatedAt: "2025-08-02T07:26:27.000Z",
    name: "invoices_view",
    description: "สามารถเข้าถึงเมนู Invoices",
    uuid: "1a70e08e-s495-85d4-p675-uf92b7ac5052",
    action: "view",
    resource: "Merchant",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: false,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 66,
    permissionId: 26,
    isPublic: 1,
    createdAt: "2025-08-02T07:26:27.000Z",
    updatedAt: "2025-08-02T07:26:27.000Z",
    name: "buyCredit_view",
    description: "สามารถเข้าถึงเมนู buy Credit",
    uuid: "1a70e08e-s495-85d4-p685-uf92b8ac5052",
    action: "view",
    resource: "BuyCredit",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 66,
    permissionId: 4,
    isPublic: 0,
    createdAt: "2025-10-11T15:06:50.000Z",
    updatedAt: "2025-10-11T15:06:50.000Z",
    name: "feePayIn_view",
    description: "สามารถเข้าถึงเมนู Approve Topup",
    uuid: "9a6b2b0c-937e-4eb9-8106-5494bbbcc697",
    action: "view",
    resource: "Deposit",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: false,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T23:12:57.000Z",
  },
  {
    roleId: 66,
    permissionId: 27,
    isPublic: 1,
    createdAt: "2025-11-05T16:48:41.000Z",
    updatedAt: "2025-11-05T16:48:43.000Z",
    name: "approve_transaction",
    description: "สามารถเข้าถึงเมนู Transaction not found",
    uuid: "1a70e08e-s495-85d4-p685-uf92b8ac9963",
    action: "view",
    resource: "Deposit",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 66,
    permissionId: 28,
    isPublic: 1,
    createdAt: "2025-12-16T03:43:45.000Z",
    updatedAt: "2025-12-19T03:43:45.000Z",
    name: "verify_customer_view",
    description: "สามารถเข้าถึงเมนู รายการตรวจสอบลูกค้า",
    uuid: "dadebd63-67e9-488d-9179-5c672a17b7fd",
    action: "view",
    resource: "Customer",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-12-01T13:56:59.000Z",
    updated_at: "2025-12-01T13:57:03.000Z",
  },
];
export const ownerPermissionsData = [
  {
    roleId: 72,
    permissionId: 1,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "dashboard_view",
    description: "สามารถเข้าถึงเมนู สถานะบัญชี",
    uuid: "3a2959db-a276-45d2-a700-5f2fbf67f289",
    action: ["view", "add", "edit", "del"],
    resource: "Dashboard",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:16.000Z",
    updated_at: "2025-02-08T23:18:08.000Z",
  },
  {
    roleId: 72,
    permissionId: 2,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "customer_account_view",
    description: "สามารถเข้าถึงเมนู Customer",
    uuid: "035d56e7-4720-4eb4-9d4e-60be5d46d46a",
    action: ["view", "add", "edit", "del"],
    resource: "Customer",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 3,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "deposit_customer_transactions_view",
    description: "สามารถเข้าถึงเมนู Deposit",
    uuid: "4cbae83a-081a-44cd-81be-4bf67801f164",
    action: ["view", "add", "edit", "del"],
    resource: "Deposit",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 7,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "withdraw_customer_transactions_view",
    description: "สามารถเข้าถึงเมนู ธุรกรรมลูกค้า - ถอน withdraw-transaction",
    uuid: "11cf9e86-8673-40d2-946b-2cd3ad72ac1a",
    action: ["view", "add", "edit", "del"],
    resource: "Withdraw",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 12,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "merchant_transfer_view",
    description: "สามารถเข้าถึงเมนู รายการโอน client-transfer",
    uuid: "24e2b988-5c7e-4a17-a32a-49bef98ded1e",
    action: ["view", "add", "edit", "del"],
    resource: "BankAccount",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 13,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "statement_view",
    description: "สามารถเข้าถึงเมนู รายการเดินบัญชี statement",
    uuid: "5e9bb337-9067-40d2-aae2-f5fed12309ab",
    action: ["view", "add", "edit", "del"],
    resource: "BankAccount",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 15,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "manage_user_view",
    description: "สามารถเข้าถึงเมนู ผู้ใช้งาน user",
    uuid: "5f2abe4f-b397-43dc-b9a3-502442c5a5aa",
    action: ["view", "add", "edit", "del"],
    resource: "User",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 16,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "activity_user_view",
    description: "สามารถเข้าถึงเมนู บันทึกกิจกรรม user-activity",
    uuid: "64b2adb5-4c40-410f-b25a-83c46db10022",
    action: ["view", "add", "edit", "del"],
    resource: "User",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 17,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "role_view",
    description: "สามารถเข้าถึงเมนู Role",
    uuid: "8278c391-bff9-4187-86c1-385939b119e1",
    action: ["view", "add", "edit", "del"],
    resource: "User",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 18,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "setting_view",
    description: "สามารถเข้าถึงเมนู setting",
    uuid: "b3e6ab5c-a54d-400e-b95b-51896247fc12",
    action: ["view", "add", "edit", "del"],
    resource: "Setting",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-08T05:05:37.000Z",
  },
  {
    roleId: 72,
    permissionId: 19,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "ApiDocumentation_view",
    description: "สามารถเข้าถึงเมนู Api Documentation",
    uuid: "5b30e08e-d495-45d4-a675-bf92b7ac5051",
    action: ["view", "add", "edit", "del"],
    resource: "ApiDocumentation",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-08T05:05:37.000Z",
    updated_at: "2025-02-14T01:18:59.000Z",
  },
  {
    roleId: 72,
    permissionId: 20,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "auto_slip_check_with_Qr",
    description: "สามารถเข้าถึงเมนู ตรวจสอบสลิป",
    uuid: "2b30e08e-i495-75d4-f675-bf92b7ac5051",
    action: ["view", "add", "edit", "del"],
    resource: "CheckSlip",
    attributes: "*",
    conditions: "Owner",
    flatpermission: "",
    ispublic: true,
    created_at: "2025-02-26T05:05:37.000Z",
    updated_at: "2025-07-06T01:18:59.000Z",
  },
  {
    roleId: 72,
    permissionId: 21,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "check_slip_without_Qr",
    description: "สามารถเข้าถึงเมนู รายการตรวจสอบสลิป",
    uuid: "1a70e08e-s495-85d4-f675-uf92b7ac5051",
    action: ["view", "add", "edit", "del"],
    resource: "CheckSlip",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 72,
    permissionId: 22,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "manage_merchant_view",
    description: "สามารถเข้าถึงเมนู จัดการร้านค้า",
    uuid: "1a70e08e-s495-8574-f675-uf92b7ac5052",
    action: ["view", "add", "edit", "del"],
    resource: "Merchant",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 72,
    permissionId: 23,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "bankAccount_view",
    description: "สามารถเข้าถึงเมนู จัดการธนาคาร",
    uuid: "1a70e08e-s495-85d4-f675-uf99b7ac5052",
    action: ["view", "add", "edit", "del"],
    resource: "BankAccount",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 72,
    permissionId: 24,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "chart_report_view",
    description: "สามารถเข้าถึงเมนู report",
    uuid: "1a70e08e-s495-85d4-p675-uf92b7ac5052",
    action: ["view", "add", "edit", "del"],
    resource: "Report",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
  {
    roleId: 72,
    permissionId: 26,
    isPublic: 1,
    createdAt: "2025-08-17T11:16:31.000Z",
    updatedAt: "2025-08-17T11:16:31.000Z",
    name: "buyCredit_view",
    description: "สามารถเข้าถึงเมนู buy Credit",
    uuid: "1a70e08e-s495-85d4-p685-uf92b8ac5052",
    action: ["view", "add", "edit", "del"],
    resource: "BuyCredit",
    attributes: "*",
    conditions: "Owner",
    flatpermission: null,
    ispublic: true,
    created_at: "2025-07-06T13:34:16.000Z",
    updated_at: "2025-07-06T13:34:19.000Z",
  },
];
export const rawRoleData = [
  {
    id: 65,
    UUID: "cd64bc33-4060-425f-8142-86117e69c40f",
    name: "SuperOwner",
    explain: "Guest SuperOwner",
    roleName: "SuperOwner",
    merchantId: 32,
    isPublic: true,
    permission: rawPermissionsData,
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 66,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Subowner",
    explain: "Guest Subowner",
    roleName: "Subowner",
    merchantId: 32,
    isPublic: true,
    permission: rawPermissionsData,
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 72,
    UUID: "45142778-1e2a-4b18-b6f0-e5e95a1eebbc",
    name: "Owner",
    explain: "Guest Owner",
    roleName: "Owner",
    merchantId: 32,
    isPublic: true,
    permission: rawPermissionsData,
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
];

export const defaultDataRole = [
  // {
  //   id: 1,
  //   UUID: "cd64bc33-4060-425f-8142-86117e69c40f",
  //   name: "SuperOwner",
  //   explain: "Default SuperOwner",
  //   roleName: "SuperOwner",
  //   merchantId: 32,
  //   isPublic: true,
  //   permission: [],
  //   createdAt: "2025-08-02T07:20:27.000Z",
  //   updatedAt: "2025-08-02T07:20:27.000Z",
  // },
  {
    id: 2,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Subowner",
    explain: "Default Subowner",
    roleName: "Subowner",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  
  // {
  //   id: 3,
  //   UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
  //   name: "Owner",
  //   explain: "Default Owner",
  //   roleName: "Owner",
  //   merchantId: null,
  //   isPublic: true,
  //   permission: [],
  //   createdAt: "2025-08-02T07:20:27.000Z",
  //   updatedAt: "2025-08-02T07:20:27.000Z",
  // },
  {
    id: 7,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Head_Finance",
    explain: "Default Head_Finance",
    roleName: "Head_Finance",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 4,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Finance",
    explain: "Default Finance",
    roleName: "Finance",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 8,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Head_Admin",
    explain: "Default Head_Admin",
    roleName: "Head_Admin",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 5,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Administrators",
    explain: "Default Administrators",
    roleName: "Administrators",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 6,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "QA",
    explain: "Default QA",
    roleName: "QA",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 10,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Manager",
    explain: "Default manager",
    roleName: "Manager",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
  {
    id: 9,
    UUID: "d12a5259-c251-47ad-934a-2c1ba1c0efd6",
    name: "Other",
    explain: "Default other",
    roleName: "Other",
    merchantId: 32,
    isPublic: true,
    permission: [],
    createdAt: "2025-08-02T07:20:27.000Z",
    updatedAt: "2025-08-02T07:20:27.000Z",
  },
];

export const menu = [
  {
    key: "1",
    icon: "DashboardOutlined",
    labelKey: "dashboard",
    path: "/dashboard",
    AuthorizedRole: [
      "SuperOwner",
      "Finance",
      "Administrators",
      "Subowner",
      "Owner",
    ],
    access: ["dashboard_view"],
    features: [
      "all", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม Merchant
    ],
  },
  {
    key: "2",
    icon: "TeamOutlined",
    labelKey: "Customer's",
    AuthorizedRole: ["SuperOwner", "Administrators", "Subowner", "Owner"],
    access: ["customer_account_view"],
    children: [
      {
        key: "21",
        labelKey: "Customer account",
        path: "/bank-bank-customer",
        permission: ["customer_account_view"],
      },
    ],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
    ],
  },
  {
    key: "3",
    icon: "PlusOutlined",
    labelKey: "deposit",
    AuthorizedRole: ["SuperOwner", "Finance", "Subowner", "Owner"],
    access: ["deposit_customer_transactions_view", "feePayIn_view"],
    children: [
      {
        key: "31",
        labelKey: "Customer transactions",
        path: "/deposit-transaction",
        permission: ["deposit_customer_transactions_view"],
      },
      {
        key: "32",
        labelKey: "Fee Pay In",
        path: "/feePayIn",
        permission: ["feePayIn_view"],
      },
      {
        key: "33",
        labelKey: "transaction not found",
        path: "/top-up-approval",
        permission: ["approve_transaction"],
      },
    ],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
    ],
  },
  {
    key: "4",
    icon: "MinusOutlined",
    labelKey: "withdraw",
    AuthorizedRole: ["SuperOwner", "Finance", "Subowner", "Owner"],
    access: [
      "withdraw_customer_transactions_view",
      "feePayOut_view",
      "approve_transaction",
    ],
    children: [
      {
        key: "41",
        labelKey: "Customer transactions",
        path: "/withdraw-transaction",
        permission: ["withdraw_customer_transactions_view"],
      },
      {
        key: "42",
        labelKey: "Fee Pay Out",
        path: "/feePayOut",
        permission: ["feePayOut_view"],
      },
    ],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
      "approval", // สิทธิ์ปุ่ม/ฟีเจอร์: อนุมัติ
    ],
  },
  {
    key: "5",
    icon: "HistoryOutlined",
    labelKey: "Bank account",
    AuthorizedRole: ["SuperOwner", "Subowner", "Owner"],
    access: ["bankAccount_view", "merchant_transfer_view", "statement_view"],
    children: [
      {
        key: "51",
        labelKey: "Manage account",
        path: "/bank-account",
        permission: ["bankAccount_view"],
      },
      {
        key: "52",
        labelKey: "Money transfer",
        path: "/client-transfer",
        permission: ["merchant_transfer_view"],
      },
      {
        key: "53",
        labelKey: "statement",
        path: "/statement",
        permission: ["statement_view"],
      },
    ],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
      "tranfer", // สิทธิ์ปุ่ม/ฟีเจอร์: การโอน
    ],
  },
  {
    key: "6",
    icon: "BankOutlined",
    labelKey: "manage merchant",
    path: "/manage-merchant",
    AuthorizedRole: ["SuperOwner", "Subowner", "Owner"],
    access: ["manage_merchant_view"],
  },
  {
    key: "7",
    icon: "CheckTheSlip",
    labelKey: "CheckTheSlip",
    AuthorizedRole: ["SuperOwner", "Subowner", "Owner", "Finance"],
    access: ["auto_slip_check_with_Qr", "check_slip_without_Qr"],
    children: [
      {
        key: "71",
        labelKey: "autoSlipCheckWithQr",
        path: "/verifyslip-transactions",
        permission: ["auto_slip_check_with_Qr"],
      },
      {
        key: "72",
        labelKey: "checkSlipWithOutQr",
        path: "/checkSlipWithOutQr",
        permission: ["check_slip_without_Qr"],
      },
    ],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
      "verify", // สิทธิ์ปุ่ม/ฟีเจอร์: ตรวจสอบ
    ],
  },
  {
    key: "8",
    icon: "UserOutlined",
    labelKey: "user",
    AuthorizedRole: ["SuperOwner", "Subowner", "Owner"],
    access: ["manage_user_view", "activity_user_view", "role_view"],
    children: [
      {
        key: "81",
        labelKey: "manage user",
        path: "/user",
        permission: ["manage_user_view"],
      },
      {
        key: "83",
        labelKey: "Role",
        path: "/role",
        permission: ["role_view"],
      },
      {
        key: "82",
        labelKey: "activity",
        path: "/user-activity",
        permission: ["activity_user_view"],
      },
    ],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
    ],
  },
  {
    key: "12",
    icon: "InvoicesOutlined",
    labelKey: "Invoices",
    path: "/invoices",
    AuthorizedRole: ["SuperOwner", "Subowner"],
    access: ["invoices_view"],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
      "verify", // สิทธิ์ปุ่ม/ฟีเจอร์: ตรวจสอบ
    ],
  },
  {
    key: "13",
    icon: "buyCreditOutlined",
    labelKey: "BuyCredit",
    path: "/buyCredit",
    AuthorizedRole: ["SuperOwner", "Subowner", "Owner"],
    access: ["buyCredit_view"],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
      "buy", // สิทธิ์ปุ่ม/ฟีเจอร์: ซื้อ
    ],
  },
  {
    key: "11",
    icon: "ReportOutlined",
    labelKey: "report",
    AuthorizedRole: ["SuperOwner", "Subowner", "Owner"],
    access: ["chart_report_view"],
    children: [
      {
        key: "111",
        labelKey: "chart report",
        path: "/chart-report",
        permission: ["chart_report_view"],
      },
    ],
    features: [
      "verify", // สิทธิ์ปุ่ม/ฟีเจอร์: ซื้อ
    ],
  },
  {
    key: "9",
    icon: "SettingOutlined",
    labelKey: "setting",
    path: "/setting",
    AuthorizedRole: ["SuperOwner", "Subowner", "Owner"],
    access: ["setting_view"],
    features: [
      "deteil", // สิทธิ์ปุ่ม/ฟีเจอร์: รายละเอียด
      "add", // สิทธิ์ปุ่ม/ฟีเจอร์: เพิ่ม
      "edit", // สิทธิ์ปุ่ม/ฟีเจอร์: แก้ไข
      "del", // สิทธิ์ปุ่ม/ฟีเจอร์: ลบ /ยกเลิก
      "setting", // สิทธิ์ปุ่ม/ฟีเจอร์: ตั้งค่า
    ],
  },
  {
    key: "10",
    icon: "FileTextOutlined",
    labelKey: "api documentation",
    path: null,
    AuthorizedRole: [
      "SuperOwner",
      "Finance",
      "Administrators",
      "Subowner",
      "Owner",
    ],
    access: ["ApiDocumentation_view"],
    features: [
      "all", // สิทธิ์ปุ่ม/ฟีเจอร์: ตั้งค่า
    ],
  },
];
